import { render, staticRenderFns } from "./AppContainer.vue?vue&type=template&id=1f10a9fa&lang=pug"
import script from "./AppContainer.vue?vue&type=script&lang=ts"
export * from "./AppContainer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports